import React, { useEffect } from 'react';
import { useLanguage } from './context/LanguageContext';
import { useMedia } from './context/MediaContext';
import { useScoreboard } from './context/ScoreboardContext';

const MusicOverlay = ({ onClose }) => {
  const { t } = useLanguage();
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onClose]);
  const { 
    songs, 
    playAudio, 
    stopAudio, 
    isPlaying, 
    currentSongIndex
  } = useMedia();
  const { isEntertainmentEnabled } = useScoreboard();

  // Log state changes
  useEffect(() => {
    console.log('Music state changed - isPlaying:', isPlaying, 'currentSongIndex:', currentSongIndex);
  }, [isPlaying, currentSongIndex]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold">{t('entertainment.inGamePlayerTitle')}</h1>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>
        </div>

        <div className="space-y-4">
          {!isEntertainmentEnabled ? (
            <div className="text-center text-gray-500 py-8">
              In game music player requires a valid license.
              Please activate your license in the settings.
            </div>
          ) : songs.some(song => song !== null) ? (
            <div className={`grid ${songs.filter(s => s).length > 5 ? 'grid-cols-2 gap-4' : 'grid-cols-1'}`}>
            {songs.map((song, index) => (
              song && (
                <div
                  key={index}
                  className="flex items-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
                >
                  <div className="flex items-center gap-4">
                    <span className="text-sm font-medium text-gray-500 w-6">{index === 9 ? 10 : index + 1}</span>
                    <button
                      onClick={() => {
                        if (currentSongIndex === index && isPlaying) {
                          stopAudio();
                        } else {
                          playAudio(song, index);
                        }
                      }}
                      className={`w-10 h-10 flex items-center justify-center text-white rounded-full transition-colors ${currentSongIndex === index && isPlaying ? 'bg-blue-500 hover:bg-blue-600' : 'bg-amber-500 hover:bg-amber-600'}`}
                      data-testid={`song-${index}-${currentSongIndex === index && isPlaying ? 'pause' : 'play'}-button`}
                    >
                      {currentSongIndex === index && isPlaying ? (
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                          <rect x="6" y="4" width="4" height="16" />
                          <rect x="14" y="4" width="4" height="16" />
                        </svg>
                      ) : (
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M8 5v14l11-7z"/>
                        </svg>
                      )}
                    </button>
                    <span className="text-sm font-medium truncate">{song.name}</span>
                  </div>
                </div>
              )
            ))}
            </div>
          ) : (
            <div className="text-center text-gray-500 py-8">
              {t('entertainment.noSongs')}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MusicOverlay;
